module.exports = __webpack_public_path__ + "img/ss_green-08.0cfa58e1.jpg";